import { type IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageUpdatedNewGlobal } from 'entities/Conversation/events/EventMessageUpdatedNewGlobal'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export const useEventMessageUpdatedNew = (conversationMessageStore: ConversationMessagesStore) => {
  const { conversationStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    conversationStore.updateItem(data.conversation)
    if (data.message.conversation_id === conversationMessageStore.conversationId) {
      conversationMessageStore.insertItems([data.message])
    }
  }

  useEventMessageUpdatedNewGlobal(handler)
}
